/*
    Create by fanglijuan 2017-05-25
*/
'use strict';
angular.module("sortAccountSynchroToGroupModule", [])
    .controller("sortAccountSynchroToGroupCtrl", ["$scope", "$location", "$stateParams", "$q", "$filter", "$timeout", "$modalInstance", "trsHttpService", 'treeService', "$state", "$validation", "trsspliceString", "globleParamsSet", "accountSynchroToGroupService", "modalDialog", "item",'nameChange',
        function($scope, $location, $stateParams, $q, $filter, $timeout, $modalInstance, trsHttpService, treeService, $state, $validation, trsspliceString, globleParamsSet, accountSynchroToGroupService, modalDialog, item,nameChange) {
            initStatus();
            initData();

            function initStatus() {
                $scope.status = {
                    groupName: item.DEPARTNAME,
                    synGroupId: item.SYNGROUPID,
                    currGroupName: "",
                    departId: item.DEPARTID,
                };
                $scope.data = {
                    globalName:nameChange.globalName,
                    modalTitle: "组织同步",
                    "navTitle": "排序",
                    currMLFGroup: [],
                };
            }
            /**
             * [initData description]初始化数据
             */
            function initData() {
                getYPGroupDetail();
            }
            //获取媒立方对应的8531信息
            function getYPGroupDetail() {
                var params = {
                    "serviceid": "mlf_groupmanagement",
                    "methodname": "getYPGroupDetail",
                    "SynGroupId": $scope.status.synGroupId,
                    /*"DepartId": $scope.status.departId,*/
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then(function(data) {
                    $scope.data.currMLFGroup = data;
                    /*dealWithPath($scope.data.currMLFGroup.MLFGROUPPATH);*/
                });
            }
            /**
             * [dealWithPath description]截取当前组织名称
             * @param  {[type]} groupPath [description]
             * @return {[type]}           [description]
             */
            /*function dealWithPath(groupPath) {
                var paths = groupPath.split("/");
                $scope.status.currGroupName = paths[paths.length - 1];
            }*/

            //排序：点击确定
            $scope.confirm = function() {
                var params = {
                    "serviceid": "mlf_groupmanagement",
                    "methodname": "sortSetUpMLFGroup",
                    "FromGroupId": $scope.data.currMLFGroup.MLFGROUPID, //原组织id
                    "NewOrder": $scope.data.currMLFGroup.SYNORDER, //8531排序位置(新的)
                    "SynGroupId": $scope.status.synGroupId,
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then(function(data) {
                    /*modalDialog.alertType("同步成功", "", "success", false, function() {
                        $modalInstance.close('success');
                    });*/
                    var res = data.ISSUCCESS == 'true' ? 'success' : 'error';
                    modalDialog.alertType(data.REPORTS[0].DETAIL, "", res, false, function() {
                        $modalInstance.close();
                    });
                });
            };
            //取消
            $scope.cancel = function() {
                $modalInstance.dismiss();
            };
        }
    ]);
